<template>
  <div v-if="dataLoaded">

    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/etim`)"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn
          ref="save"
          class="capitalize ctrl-button right"
          :color="readOnly ? 'grey-5' :'ctrl-turquoise'"
          :label="readOnly ? getString('action.edit') : getString('action.save')"
          @click="saveChanges"
          :icon-right="readOnly ? 'edit' : 'save'"
        />
      </div>
    </div>

    <div class="row gutter-sm q-mb-lg">
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString('module.logs.details.general.title') }}
        </p>
        <div class="card-block">
          <!-- Label -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.label"
              readonly
              :float-label="getString('label')">
            </q-input>
          </q-field>
          <!-- Description -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.description"
              readonly
              :float-label="getString('description')">
            </q-input>
          </q-field>
          <!-- Code -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.code"
              readonly
              :float-label="getString('module.etim.feature.properties.code')">
            </q-input>
          </q-field>
          <!-- Postfix -->
          <q-field class="q-mb-md" v-if="data.postfix">
            <q-input type="text" v-model="data.postfix"
              readonly
              :float-label="getString('module.etim.feature.properties.postfix')">
            </q-input>
          </q-field>
          <!-- Unit -->
          <q-field class="q-mb-md" v-if="data.unit">
            <q-input type="text" v-model="data.unit"
              readonly
              :float-label="getString('module.etim.feature.properties.unit')">
            </q-input>
          </q-field>
          <!-- Information -->
           <q-field class="q-mb-md">
            <div class="card-title--small">{{ getString(null, 'Information', 'Informatie') }}</div>
                <tiny-editor
                  tinymce-script-src="https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.11/tinymce.min.js"
                  :init="tinyConfig()"
                  ref="tm"
                  :disabled="readOnly"
                  v-model="data.information">
                </tiny-editor>
          </q-field>
        </div>
      </div>
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString('additional') }}
        </p>
        <div class="card-block">
          <!-- Unit -->
          <q-field class="q-mb-md">
            <q-select v-if="data.category"
              :float-label="getString('category')"
              v-model="data.category.id"
              :options="categories"
              @input="val => updateCategory(val)"
              class="full-width q-ml-md q-mr-md"
            />
            <q-select v-else
              :float-label="getString('category')"
              v-model="noCategory"
              :options="categories"
              @input="val => updateCategory(val)"
              class="full-width q-ml-md q-mr-md"
            />
          </q-field>

          <!-- Color -->
          <q-field class="q-mb-md">
            <q-select
              :float-label="getString('colors.color')"
              v-model="data.color"
              :options="colors"
              class="full-width q-ml-md q-mr-md"
            />
          </q-field>

          <!-- Visible -->
          <q-field>
            <q-toggle v-model="data.visible" color="secondary"
              :disable="readOnly"
              @input="toggle(data.visible, 'visible')">
              <span style="margin-left: 1em;">
                {{ getString('module.etim.feature.properties.visible') }}
              </span>
            </q-toggle>
          </q-field>

          <!-- Filterable -->
          <q-field>
            <q-toggle v-model="data.filterable" color="secondary"
              :disable="readOnly"
              @input="toggle(data.filterable, 'filterable')">
              <span style="margin-left: 1em;">
                {{ getString('module.etim.feature.properties.filterable') }}
              </span>
            </q-toggle>
          </q-field>

          <!-- Brochure -->
          <q-field>
            <q-toggle v-model="data.brochure" color="secondary"
              :disable="readOnly"
              @input="toggle(data.brochure, 'brochure')">
              <span style="margin-left: 1em;">
                {{ getString('module.etim.feature.properties.brochure') }}
              </span>
            </q-toggle>
          </q-field>

          <!-- Website -->
          <q-field>
            <q-toggle v-model="data.show_on_overview" color="secondary"
              :disable="readOnly"
              @input="toggle(data.show_on_overview, 'show_on_overview')">
              <span style="margin-left: 1em;">
                {{ getString(null, 'Visible on overview', 'Zichtbaar op overzicht') }}
              </span>
            </q-toggle>
          </q-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';

import saveChanges from '@/mixins/detailViews/saveChanges';
import fetchDetail from '@/mixins/detailViews/fetchDetail';

import getString from '@/helpers/GetStrings';
import common from '../common';

const TinyEditor = require('@tinymce/tinymce-vue').default;

export default {
  data() {
    return {
      successMessage: getString('module.etim.feature.edit.save.success'),
      readOnly: true,
      noCategory: null,
      dataLoaded: false,
      categories: [],
      colors: [
        {
          label: getString('colors.red'),
          value: 'red',
        },
        {
          label: getString('colors.blue'),
          value: 'blue',
        },
        {
          label: getString('colors.green'),
          value: 'green',
        },
      ],
      data: {
        label: '',
        information: '',
        description: '',
        unit: '',
        postifix: '',
        code: '',
        category: {
          name: '',
          id: '',
        },
        color: '',
        filterable: false,
        visible: false,
        brochure: false,
        show_on_overview: false,
      },
    };
  },

  components: {
    TinyEditor,
  },

  mixins: [
    fetchDetail,
    common,
    saveChanges,
  ],
  methods: {
    getString,

    requestParams() {
      return {
        label: this.data.label,
        information: this.data.information,
        description: this.data.description,
        unit: this.data.unit,
        postifix: this.data.postifix,
        code: this.data.code,
        category: this.data.category.id,
        color: this.data.color,
        filterable: this.data.filterable,
        visible: this.data.visible,
        brochure: this.data.brochure,
        show_on_overview: this.data.show_on_overview,
      };
    },

    updateCategory(val) {
      if (!this.data.category) {
        this.data.category = {};
      }
      this.data.category.id = val;
      this.axios.put(`${this.endpoint}/${this.data.id}`, qs.stringify({ category: val }));
    },

    // Method to fetch categories
    getCategories() {
      this.axios.get('etim/category').then((res) => {
        // this.categories = res.data.categories;
        this.categories = res.data.categories.map(option => ({ value: option.id, label: option.name }));
      }).catch((err) => {
        console.warn(err);
      });
    },

    toggle(value, param) {
      this.axios.put(`${this.endpoint}/${this.data.id}`, qs.stringify({ [param]: value ? 1 : 0 }));
    },

    tinyConfig() {
      return {
        readOnly: false,
        height: 200,
        menubar: false,
        branding: false,
        browser_spellcheck: true,
        plugins: ['link', 'code'],
        toolbar: [
          'undo redo | formatselect | bold italic | link | alignleft aligncenter alignright',
        ],
        style_formats: [
          { title: 'Paragraph', format: 'p' },
          { title: 'Heading 1', format: 'h1' },
          { title: 'Heading 2', format: 'h2' },
        ],
        pagebreak_split_block: false,
      };
    },
  },
  filters: {
    checkEmpty(value) {
      return value === null || value === '' ? '-' : value;
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>


<style lang="stylus" scoped>
@import '~variables';
.data-title
  font-weight 700

.data-content
  word-break break-all

</style>
